import * as React from 'react';
import User, { UserOktaStatus } from '../../../../models/user';
import UserManager from './userManager';

/**
 * Create a new user
 */
const AddUser = () => {
  const defaultUser: User = {
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    role: 'User',
    accessLevel: '',
    status: UserOktaStatus.ACTIVE,
    enhancedData: false,
    title: '',
    department: '',
    assignedApps: [],
    assignedClients: [],
    assignedTags: [],
    assignedSegmentation: [],
    isFederated: false,
    activate: true
  };

  return <UserManager loading={false} user={defaultUser} isNewUser={true} />;
};
export default AddUser;
